import { TextTabId, RequestSchema } from "./types";
import { TopicWithScore } from "../../../../FuturebilityCockpit/hooks";
import { ReflectionType } from "../../../../../../types/domain-types";
import { DEFAULT_BENCHMARK_VALUE } from "../../../../../../constants";

export const getFilteredTopics = (
  topics: TopicWithScore[],
  activeTextTab: TextTabId
) => {
  const leverages = [...topics]
    .sort((a, b) => b.scoreVsBenchmarkDifference - a.scoreVsBenchmarkDifference)
    .slice(0, 3);
  const challenges = [...topics]
    .sort((a, b) => a.scoreVsBenchmarkDifference - b.scoreVsBenchmarkDifference)
    .slice(0, 3);
  const all = [...topics]
    .filter(t => t.category === activeTextTab)
    .sort(
      (a, b) =>
        parseInt(a.info.cubeSide ?? "0", 10) -
        parseInt(b.info.cubeSide ?? "0", 10)
    );

  return {
    leverages,
    challenges,
    all,
  };
};

export function buildReflectionTestSetItem(
  topics: TopicWithScore[],
  reflectionType: ReflectionType
): RequestSchema["items"] {
  return topics.map(topic => ({
    testSetId: topic._id,
    name: topic.info.name ?? "N/A",
    cubeSide: topic.info.cubeSide,
    defaultBenchmark:
      (topic.info.defaultBenchmark ?? DEFAULT_BENCHMARK_VALUE) * 100,
    type: reflectionType,
    score: topic.score,
  }));
}
